/**
 * A stand-in says so where it is shown. SPEC §8.4.
 *
 * Not in a footnote and not in a covering note: on the file itself, above
 * everything else on the screen, so that nobody reads a generated application
 * as a real one.
 */

import { bi, type Provenance } from "@ksidc/ontology";
import { useLang } from "@ksidc/client";
import { Callout } from "./ui.js";

export function GeneratedBanner({ provenance }: { provenance: Provenance }): JSX.Element | null {
  const { t } = useLang();
  if (provenance.kind !== "generated") return null;

  return (
    <Callout
      tone="alarm"
      title={bi(
        "This is not a real application",
        "ഇത് ഒരു യഥാർത്ഥ അപേക്ഷയല്ല",
      )}
      provenance={provenance}
    >
      <p style={{ marginBottom: 0 }}>
        {t(
          bi(
            "Everything on this page is made up. It is here so the system can be shown working before real applications arrive. No office has received this application. None of the dates are real. Nothing on this page gives anyone any right.",
            "ഈ താളിലുള്ളതെല്ലാം താൽക്കാലിക വിവരമാണ്. യഥാർത്ഥ ഫയലുകൾ വരുന്നതിന് മുൻപ് സംവിധാനം പ്രവർത്തിക്കുന്നത് കാണിക്കാൻ ഉണ്ടാക്കിയതാണ്. ഒരു ഓഫീസിനും ഇത് ലഭിച്ചിട്ടില്ല, ഇതിലെ ഒരു തീയതിയും യഥാർത്ഥമല്ല, ഇത് ആർക്കും ഒരു അവകാശവും നൽകുന്നില്ല.",
          ),
        )}
      </p>
    </Callout>
  );
}
